export class TotalOrderSummaryFilter {
  companyCode: string;
  cropYear: number;
  productLine: string;
  marketingBrand: string;
  account: string;
  txtAccountNo: string;
  accountName: string;
  district: string;
  city: string;
  state: string;
  productName: string;
  orderNumber: string;
  orderType: string;
  seedSize: string;
  packageSize: string;
  treatment: string;
  brandExactMatch: boolean;
}
